import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SisLoader from "../../../../../widgets/loader";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import { IGGCargoMachin } from "../../components/CargoMachinCom/IGGCargoMachin";

export const IGGCargoMachinList = () => {
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [IGG_Data, set_IGG_Data] = useState([]);

  const GET_SHIP_IGG_LISTS = async () => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);

      post(ApiURL.cargo_machinery_igg_list_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_loader(false);
          set_IGG_Data(res?.response_data);
        }
      });

      set_loader(false);
    } catch (error) {
      set_loader(false);
      console.error("Error boiler list:", error);
    }
  };

  useEffect(() => {
    GET_SHIP_IGG_LISTS();
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {IGG_Data ? (
              <>
                {IGG_Data?.map((_items) => (
                  <>
                    <IGGCargoMachin eng_log_basic_id={eng_log_basic_id} _items={_items} />
                  </>
                ))}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
};
